export const cancelPreviousRequestIfConsecutive = (
  abortControllerRef: React.MutableRefObject<AbortController | null>,
): void => {
  if (abortControllerRef.current) {
    abortControllerRef.current.abort();
    console.error('Requêtes précédentes annulées');
  }
};
